import { Sex } from "@/helpers/enums";

/**
 * Per-dog box inclusion (issue #50).
 *
 * A dog can be switched out of the current box without losing any answers:
 * the flag lives on the dog form (`excludedFromBox`), so it persists through
 * the normal form machinery and an ABSENT flag means included — older saved
 * quizzes need no migration.
 *
 * Excluded dogs keep receiving plan-config updates so switching them back in
 * is instant; they are filtered out of pricing, review totals and the
 * checkout payload instead.
 */
export function isDogIncluded(form: { excludedFromBox?: boolean } | null | undefined): boolean {
  return !form?.excludedFromBox;
}

/** "his" / "her", falling back to "their" when sex was never answered. */
export function dogPossessive(sex: unknown): string {
  if (sex === Sex.MALE) return "his";
  if (sex === Sex.FEMALE) return "her";
  return "their";
}
